module.exports = __webpack_public_path__ + "img/menu.dfdd9727.png";